export default window.commonOpenClose = (id, event) => {
  const day = id.split("-").pop();
  let name = id.slice(0, -(day.length + 1));
  const closed = name.split("-").pop();
  name = name.slice(0, -(closed.length + 1));

  let total = 0;
  let days = 0;

  for (let i = 0; i < 7; i += 1) {
    const time = $(`#${name}-${event}-${i}`).val();

    if (time && time.length > 0) {
      const parts = time.split(":");
      const h = Number(parts[0]);
      const m = Number(parts[1]);

      total += m + h * 60;
      days += 1;
    }
  }

  const average = total / days;
  const h = Math.round(average / 60);
  const m = Math.round(average % 60);

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};
